// formatDateVN(input) -> returns string in format "HH:mm dd/MM/yyyy" in Asia/Ho_Chi_Minh timezone
function formatDateVN(input){
  try{
    const d = input ? new Date(input) : new Date();
    // Use Intl to respect timezone and leading zeroes
    const parts = new Intl.DateTimeFormat('vi-VN', {
      timeZone: 'Asia/Ho_Chi_Minh',
      hour: '2-digit', minute: '2-digit', hour12: false,
      day: '2-digit', month: '2-digit', year: 'numeric'
    }).formatToParts(d);
    const map = {};
    parts.forEach(p=>{ map[p.type] = p.value; });
    // parts include hour, minute, day, month, year
    return `${map.hour}:${map.minute} ${map.day}/${map.month}/${map.year}`;
  }catch(e){
    // fallback simple formatting
    const d = input ? new Date(input) : new Date();
    const pad = n=>String(n).padStart(2,'0');
    const hh = pad(d.getHours());
    const mm = pad(d.getMinutes());
    const dd = pad(d.getDate());
    const mo = pad(d.getMonth()+1);
    const yy = d.getFullYear();
    return `${hh}:${mm} ${dd}/${mo}/${yy}`;
  }
}

// date-only formatter: returns "dd/MM/yyyy" (no time)
function formatDateVNDate(input){
  try{
    const d = input ? new Date(input) : new Date();
    const parts = new Intl.DateTimeFormat('vi-VN', {
      timeZone: 'Asia/Ho_Chi_Minh',
      day: '2-digit', month: '2-digit', year: 'numeric'
    }).formatToParts(d);
    const map = {};
    parts.forEach(p=>{ map[p.type] = p.value; });
    return `${map.day}/${map.month}/${map.year}`;
  }catch(e){
    const d = input ? new Date(input) : new Date();
    const pad = n=>String(n).padStart(2,'0');
    const dd = pad(d.getDate());
    const mo = pad(d.getMonth()+1);
    const yy = d.getFullYear();
    return `${dd}/${mo}/${yy}`;
  }
}

module.exports = { formatDateVN, formatDateVNDate };
